// UTM auto-tagging utility
// - On first visit with any utm_* param in the URL, capture them into
//   sessionStorage under `gm_utm`. Subsequent page loads without UTMs reuse the
//   stored values, so every downstream signup gets attributed to the original
//   ad/source that brought the user in.
// - Also captures `gm_landing_path` on the first path visited within the session.
// - `getUtmPayload()` returns a plain object to spread into any waitlist /
//   contact / venue signup body.

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
];

function _read() {
  try {
    return JSON.parse(sessionStorage.getItem("gm_utm") || "null");
  } catch (_) {
    return null;
  }
}

function _write(obj) {
  try {
    sessionStorage.setItem("gm_utm", JSON.stringify(obj));
  } catch (_) {
    /* private mode / disabled — no-op */
  }
}

export function captureUtms() {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  const incoming = {};
  UTM_KEYS.forEach((k) => {
    const v = (params.get(k) || "").trim();
    if (v) incoming[k] = v.slice(0, 80);
  });

  const existing = _read() || {};
  // Only overwrite when the URL actually carries a utm_source — otherwise
  // reloading a page without params would nuke the original attribution.
  if (incoming.utm_source) {
    _write({ ...existing, ...incoming });
  } else if (!existing.utm_source) {
    // Still persist an empty envelope so downstream reads don't throw
    _write(existing);
  }

  // Capture first landing path if not already set
  if (!sessionStorage.getItem("gm_landing_path")) {
    try {
      sessionStorage.setItem(
        "gm_landing_path",
        (window.location.pathname || "/").slice(0, 120),
      );
    } catch (_) {
      /* no-op */
    }
  }

  return _read();
}

export function getUtmPayload() {
  const u = _read() || {};
  let landing = null;
  try {
    landing = sessionStorage.getItem("gm_landing_path") || null;
  } catch (_) {
    landing = null;
  }
  return {
    source: u.utm_source || null,
    utm_medium: u.utm_medium || null,
    utm_campaign: u.utm_campaign || null,
    utm_content: u.utm_content || null,
    utm_term: u.utm_term || null,
    landing_path: landing,
  };
}
